import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline, MdSubtitles } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { TiCancel } from 'react-icons/ti';
import {
  deleteSalaryStructureHr,
  getSalaryStructureHr,
} from '../../network/salaryStructureHr';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';
const SalaryStructureHr = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const [searchText, setSearchText] = useState('');
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteSalaryStructureHr(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getSalaryStructureHr] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Salary Structure', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getSalaryStructureHr] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Salary Structure', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getSalaryStructureHr] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getSalaryStructureHr],
    queryFn: () => getSalaryStructureHr(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit,
      icon: <MdModeEditOutline />,
      onClick: () => {
        navigate(`/salary-structure-hr/edit/${record?.name}`);
      },
    },
    {
      key: '2',
      label: t.submit,
      icon: <MdSubtitles />,
      onClick: () => {
        handleSubmit.mutate(record?.name);
      },
      disabled: record?.docstatus !== 0,
    },
    {
      key: '3',
      label: t.Cancel,
      icon: <TiCancel />,
      onClick: () => {
        handleCancle.mutate(record?.name);
      },
      disabled: record?.docstatus !== 1,
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.deleteSalaryStructure + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          // onCancel={cancel}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record?.name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.payrollFrequency,
      dataIndex: 'payroll_frequency',
      key: 'payroll_frequency',
    },
    // {
    //   title: t.payrollPayableAccount,
    //   dataIndex: 'payroll_payable_account',
    //   key: 'payroll_payable_account',
    // },
    {
      title: t.ModeofPayment,
      dataIndex: 'mode_of_payment',
      key: 'mode_of_payment',
    },
    {
      title: t.status,
      dataIndex: 'docstatus',
      key: 'docstatus',
      render: (text, record) => <StatusTag status={record?.docstatus} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                navigate(`/salary-structure-hr/edit/${record?.name}`);
              }}
              icon={<MdModeEditOutline />}
            />
            {record?.docstatus === 0 && (
              <Popover
                placement="top"
                title={t.submit}
                onClick={() => {
                  handleSubmit.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#28a745' }}
                  icon={<MdSubtitles />}
                />
              </Popover>
            )}
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.Cancel}
                onClick={() => {
                  handleCancle.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#ff4d4f' }}
                  icon={<TiCancel />}
                />
              </Popover>
            )}
            {record?.docstatus !== 1 && (
              <Popconfirm
                title={t.deleteSalaryStructure + ` (${record?.name})`}
                description={t.areYouSure}
                onConfirm={() => handleRemove.mutate(record?.name)}
                okText={t.yes}
                cancelText={t.no}
              >
                <Button
                  size="small"
                  type="primary"
                  danger
                  icon={<MdDelete />}
                />
              </Popconfirm>
            )} */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.HR} subTitle={t.SalaryStructure} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setSearchText}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/salary-structure-hr/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddSalaryStructure}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default SalaryStructureHr;
